import { ref, onMounted, onUnmounted } from "vue";

export function useBreakpoints() {
	const isMobile = ref(true);
	const isDesktop = ref(true);

	let media: MediaQueryList | null = null;

	const update = () => {
		if (!media) return;
		isMobile.value = media.matches;
		isDesktop.value = !media.matches;
	};

	// Read the media query only after mount. The server cannot know the width
	// and renders both headers (CSS hides one); flipping a flag during setup
	// made hydration drop a node the server had rendered — a mismatch on every
	// page. Both start true here too, so the first client render matches.
	onMounted(() => {
		media = window.matchMedia("(max-width: 1023px)");
		update();
		media.addEventListener("change", update);
	});

	onUnmounted(() => {
		if (!media) return;
		media.removeEventListener("change", update);
	});

	return { isMobile, isDesktop };
}
